import { render, staticRenderFns } from "./shop_product_block.vue?vue&type=template&id=5f10fd83&scoped=true"
import script from "./shop_product_block.vue?vue&type=script&lang=js"
export * from "./shop_product_block.vue?vue&type=script&lang=js"
import style0 from "./shop_product_block.vue?vue&type=style&index=0&id=5f10fd83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10fd83",
  null
  
)

export default component.exports